/* eslint-disable import/order */
/* eslint-disable import/first */
/* eslint-disable simple-import-sort/imports */
/* eslint-disable import/newline-after-import */
import 'stylus-ui/global.css';
import '../components/_shared/styles/TipTapEditor.scss';
import '../styles/Button.scss';
import '../styles/FeatureBG.scss';
import '../styles/Fonts.css';
import '../styles/globals.css';
import '../styles/launchnotes.css';
import '../styles/Modal.scss'; // used by modals on Team page
import '../wydr';

import 'simplebar-react/dist/simplebar.min.css';

import { QueryClientProvider as QueryClientProviderV5, QueryClient as QueryClientV5 } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { OtelInitializer } from '@/_telemetry';
import { isMobileUserAgent } from '@root/app/viewer/[pid]/_hooks/useIsMobileUserAgent';
import { checkFlagsmithAnonymousUser, clearFlagsmithAnonymousUserCookie } from '@root/utils/cookies/cookies';
import WindowsAppPhaseOutModal from '@root/v2/components/modals/WindowsAppPhaseOutModal';
import { UserSwitcher } from 'components/UserSwitcher';
import { ExperimentProvider } from 'featureflags/context';
import { ExperimentProvider as ExperimentProviderAppRouter } from '@/_lib/featureflags/context';
import flagsmith from 'flagsmith';
import { FlagsmithProvider, useFlagsmith } from 'flagsmith/react';
import { ApproveAccessModalProvider } from 'hooks/useApproveAccessModal/useApproveAccessModal';
import { useExtensionState } from 'hooks/useExtensionState';
import { ExtensionStateProvider } from 'hooks/useExtensionState/context';
import { LocalStorageFallbackProvider } from 'hooks/useLocalStorage/context';
import App from 'next/app';
import getConfig from 'next/config';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { shouldDisableTrackingPersistance } from 'pages/_document';
import { resetServerContext } from 'react-beautiful-dnd';
import { DndProvider } from 'react-dnd';
import { Provider, useDispatch, useSelector } from 'react-redux';
import ResizeObserver from 'resize-observer-polyfill';
import { getBrowserName } from 'scribe-web-shared/functions';
import { Toaster } from 'stylus-ui/Toast';
import { TooltipProvider } from 'stylus-ui/Tooltip';
import ClientOnly from 'utils/ClientOnly';
import { PersistGate } from 'utils/PersistGate';
import { selectAccount } from '../slices/accountSlice';
import { setFlagsmithProperties } from '../slices/flagsmith';
import { persistor, store } from '../store';
import { CustomHTML5Backend } from '../utils/customHTML5Backend';
import { CursiveRecorder, isElectron } from '../utils/electron';
import { formattedFlags } from '../utils/flagsmith/flagsmith';
import { pageTitle } from '../utils/pageTitleHelpers';
import { trackEvent, trackNewRelicLog } from '../utils/tracking';
import { HistoryProvider } from '../v2/contexts/History';
import { TaskProvider } from '../v2/contexts/TaskProvider';
import { NuqsAdapter } from 'nuqs/adapters/next/pages';

const { publicRuntimeConfig } = getConfig();

if (typeof window !== 'undefined' && !window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

function profitWell() {
  return {
    __html: `(function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)};
        a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+
        s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);
        })(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');`
  };
}

const defaultOptions = {
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  retry: false
};
const queryClient = new QueryClient({ defaultOptions: { queries: defaultOptions, mutations: defaultOptions } });
const queryClientV5 = new QueryClientV5({ defaultOptions: { queries: defaultOptions, mutations: defaultOptions } });

const Page = ({ Component, pageProps }) => {
  const [planAtSignUp, setPlanAtSignUp] = useState('');

  if (global.window) {
    // temp patch for flagsmith over calling from this url
    if (pageProps?.url === 'chrome-extension://okfkdaglfjjjfefdcppliegebpoegaii/src/sidepanel/sidepanel.html') {
      return <Component {...pageProps} />;
    }
    const dispatch = useDispatch();
    // TODO: REMOVE ME, this is one of the last few places where we are using redux to grab the account info
    const { account } = useSelector(selectAccount);
    const { version: extensionVersion } = useExtensionState();

    const flagsmith = useFlagsmith();

    useEffect(() => {
      // Update state with value from localStorage
      // This ensures that the code is executed in the client-side environment
      const storedPlanAtSignUp = typeof window !== 'undefined' ? global?.window?.localStorage?.getItem('planAtSignUp') : '';

      setPlanAtSignUp(storedPlanAtSignUp);
    }, []);

    useEffect(() => {
      let anonymousUserCookieVal;

      if (!account) {
        anonymousUserCookieVal = checkFlagsmithAnonymousUser();
      } else {
        clearFlagsmithAnonymousUserCookie();
      }
      const userId = account ? account.email : anonymousUserCookieVal;
      const dateJoinedTimestamp = account?.date_joined ? new Date(account.date_joined).valueOf() : undefined;
      const superOrganizationCreated = account?.active_organization?.super_organization?.created;
      const superOrganizationCreatedTimestamp = superOrganizationCreated
        ? new Date(superOrganizationCreated).valueOf()
        : dateJoinedTimestamp;

      const traits = account
        ? {
            super_organization_id: account?.active_organization?.super_organization?.id || '',
            organization_id: account?.active_organization?.id || '',
            email_address: account.email,
            first_name: account.first_name,
            last_name: account.last_name,
            date_joined: account.date_joined,
            date_joined_timestamp: dateJoinedTimestamp,
            super_organization_created_date: superOrganizationCreated || '',
            super_organization_created_date_timestamp: superOrganizationCreatedTimestamp,
            plan_name: account?.active_organization?.super_organization?.plan?.name || 'free',
            signup_method: account?.signup_method,
            browser: getBrowserName(),
            plan_at_signup: planAtSignUp,
            extension_version: extensionVersion,
            // @ts-expect-error - TODO: Does "signup_source" still exist?
            signup_source: account?.signup_source,
            sps_enabled: account?.active_organization?.smart_privacy_screen_enabled,
            mobile_or_desktop: isMobileUserAgent() ? 'mobile' : 'desktop'
          }
        : null;

      flagsmith
        .identify(userId, traits)
        .then((_) => flagsmith.getAllFlags())
        .then((flags) => {
          trackNewRelicLog('flagsmith_api_called', userId, traits);
          // @ts-expect-error - TODO: Redux types need fixing
          dispatch(setFlagsmithProperties({ flags: formattedFlags(flags), identity: userId }));
        });
    }, [account?.email, account?.active_organization?.id]);
    // Note(George): Do not add other traits as dependencies since that will increase flagsmith the usage significantly
    // If the flags should be refetched when a certain trait changes do that ad-hoc instead of relying on flagsmith.identity

    useEffect(() => {
      if (global.window?.dataLayer) {
        if (account) {
          global.window?.dataLayer.push({ event: 'start_pw', pw_user_email: account?.email });
        } else {
          global.window?.dataLayer.push({ event: 'start_pw' });
        }
      }
    }, [account?.email]);
  }

  return <Component {...pageProps} />;
};

const MyApp = ({ Component, pageProps, route }) => {
  const router = useRouter();
  const [connectionStatus, setConnectionStatus] = useState(isElectron() ? CursiveRecorder().getConnectionStatus() : 'online');

  const handleLogoutEvent = (event) => {
    // Handle login and logout for other tabs on our domain. Triggered in authSlice.js
    // This is not fired for page making the change, so it wont interfere with current tab.
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/storage_event
    if (event.storageArea === localStorage && (event.key === 'logoutEvent' || event.key === 'loginEvent') && event.newValue === 'true') {
      // @ts-expect-error - TODO: Maybe we don't need the parameter?
      window.location.reload(true);
    }
  };

  const isSidepanelBugInstance = router.query?.url === 'chrome-extension://okfkdaglfjjjfefdcppliegebpoegaii/src/sidepanel/sidepanel.html';

  useEffect(() => {
    isElectron() &&
      CursiveRecorder().checkConnectionStatus((status) => {
        setConnectionStatus(status);
      });
  }, []);

  useEffect(() => {
    trackEvent('view_page', {
      path: router.pathname
    });
  }, [router && router.pathname]);

  useEffect(() => {
    if (router.query.notification_id || router.query.notification_type || router.query.channel) {
      trackEvent('user_notified_and_returned', {
        notification_id: router.query?.notification_id,
        notification_type: router.query?.notification_type,
        channel: router.query?.channel
      });
    }
  }, [router?.query?.notification_id, router?.query?.notification_type, router?.query?.channel]);

  useEffect(() => {
    window.addEventListener('storage', handleLogoutEvent);

    return () => {
      window.removeEventListener('storage', handleLogoutEvent);
    };
  }, []);

  if (isElectron()) {
    return (
      <>
        <Head>
          <title>Application out of date</title>
        </Head>
        <ClientOnly>
          <div style={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <WindowsAppPhaseOutModal />
          </div>
        </ClientOnly>
      </>
    );
  }
  return (
    <DndProvider backend={CustomHTML5Backend}>
      <Head>
        <title>{pageTitle(router)}</title>
        <link rel='icon' href='/favicon.ico' />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <meta name='theme-color' content='#000000' />
        <link rel='apple-touch-icon' sizes='180x180' href='/apple-touch-icon.png' />
        <link rel='icon' type='image/png' sizes='32x32' href='/favicon-32x32.png' />
        <link rel='icon' type='image/png' sizes='16x16' href='/favicon-16x16.png' />
        <link rel='manifest' href='/site.webmanifest' />
        <meta name='msapplication-TileColor' content='#da532c' />
        <meta name='theme-color' content='#ffffff' />
        <meta name='description' content="See how it's done. Share how it's done." />
        {publicRuntimeConfig.enableTrackers !== 'false' && !shouldDisableTrackingPersistance(route) && (
          <>
            <Script src='https://challenges.cloudflare.com/turnstile/v0/api.js' type='text/javascript' />
            <Script
              dangerouslySetInnerHTML={profitWell()}
              type='text/javascript'
              id='profitwell-js'
              data-pw-auth='1a4e555284d217f9495ba05f13925e1e'
            />
            <noscript
              dangerouslySetInnerHTML={{
                __html:
                  '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=4922334221172329&ev=PageView&noscript=1" />'
              }}
            />
            <noscript>
              <iframe
                src='https://www.googletagmanager.com/ns.html?id=GTM-KHG3SC2'
                height='0'
                width='0'
                style={{ display: 'none', visibility: 'hidden' }}
              />
            </noscript>
          </>
        )}
      </Head>
      <OtelInitializer />
      <TooltipProvider>
        <QueryClientProvider client={queryClient}>
          <QueryClientProviderV5 client={queryClientV5}>
            <NuqsAdapter>
              {!isSidepanelBugInstance ? (
                <FlagsmithProvider
                  options={{
                    environmentID: publicRuntimeConfig.flagsmithClientId,
                    preventFetch: true
                  }}
                  flagsmith={flagsmith}
                >
                  <HistoryProvider>
                    <TaskProvider>
                      <Provider store={store}>
                        <ExperimentProvider>
                          <ExperimentProviderAppRouter>
                            <ExtensionStateProvider>
                              <LocalStorageFallbackProvider>
                                {/* @ts-expect-error - TODO: Not sure why "PersistGate" is being problematic */}
                                <PersistGate isSSR={Component.SSR} loading={null} persistor={persistor}>
                                  <ApproveAccessModalProvider>
                                    <Page Component={Component} pageProps={pageProps} />
                                    <ClientOnly>{publicRuntimeConfig?.features?.userSwitcher && <UserSwitcher />}</ClientOnly>
                                  </ApproveAccessModalProvider>
                                </PersistGate>
                              </LocalStorageFallbackProvider>
                            </ExtensionStateProvider>
                          </ExperimentProviderAppRouter>
                        </ExperimentProvider>
                      </Provider>
                    </TaskProvider>
                  </HistoryProvider>
                </FlagsmithProvider>
              ) : (
                <HistoryProvider>
                  <Provider store={store}>
                    <ExperimentProvider>
                      <ExperimentProviderAppRouter>
                        <ExtensionStateProvider>
                          <LocalStorageFallbackProvider>
                            {/* @ts-expect-error - TODO: Not sure why "PersistGate" is being problematic */}
                            <PersistGate isSSR={Component.SSR} loading={null} persistor={persistor}>
                              <ApproveAccessModalProvider>
                                <Page Component={Component} pageProps={pageProps} />
                              </ApproveAccessModalProvider>
                            </PersistGate>
                          </LocalStorageFallbackProvider>
                        </ExtensionStateProvider>
                      </ExperimentProviderAppRouter>
                    </ExperimentProvider>
                  </Provider>
                </HistoryProvider>
              )}
            </NuqsAdapter>
          </QueryClientProviderV5>
        </QueryClientProvider>
        <Toaster />
      </TooltipProvider>
    </DndProvider>
  );
};

MyApp.getInitialProps = async (appContext) => {
  // calls page's `getInitialProps` and fills `appProps.pageProps`
  resetServerContext();
  const appProps = await App.getInitialProps(appContext);

  return { ...appProps, route: appContext.router.route };
};

export default MyApp;
